// components
import SvgIconStyle from "../../../components/SvgIconStyle";

// ----------------------------------------------------------------------

const getIcon = (name) => (
  <SvgIconStyle src={`/icons/${name}.svg`} sx={{ width: 1, height: 1 }} />
);

const ICONS = {
  user: getIcon("ic_user"),
  financial: getIcon("ic_financial"),
  complaint: getIcon("ic_complaint"),
  dashboard: getIcon("ic_dashboard"),
  skills: getIcon("ic_skills"),
  orders: getIcon("ic_orders"),
  pages: getIcon("ic_pages"),
  support: getIcon("ic_support"),
  faq: getIcon("ic_faq"),
  plus: getIcon("ic_plus"),
};

const sidebarConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: "عمومی",
    items: [
      { title: "صفحه نخست", path: "/", icon: ICONS.dashboard },
      {
        title: "ثبت سفارش",
        path: ["/categories/", "/services/"],
        icon: ICONS.plus,
        children: [
          { title: "دسته بندی ها", path: "/categories/" },
          { title: "ثبت سفارش", path: "/services/" },
        ],
      },
      {
        title: "سفارشات من",
        path: "/orders/",
        icon: ICONS.orders,
      },
    ],
  },

  // MANAGEMENT
  // ----------------------------------------------------------------------
  {
    subheader: "مالی و پشتیبانی",
    items: [
      {
        title: "مالی",
        path: "/financial",
        icon: ICONS.financial,
        children: [{ title: "پرداخت ها", path: "/financial/payments" }],
      },

      {
        title: "پشتیبانی",
        path: "/support",
        icon: ICONS.support,
      },
    ],
  },
];

export default sidebarConfig;
